module.exports = __webpack_public_path__ + "img/case1.9b92faf5.jpg";